namespace SorAraBul.Administration {
    export interface UserForm {
        Username: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        Roles: Serenity.LookupEditor;
        MobilePhoneNumber: Common.PhoneEditor;
        InvoiceAddress: Serenity.TextAreaEditor;
        Password: Serenity.PasswordEditor;
        PasswordConfirm: Serenity.PasswordEditor;
        CompanyId: Serenity.LookupEditor;
    }

    export class UserForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.User';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserForm.init)  {
                UserForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailAddressEditor;
                var w2 = s.LookupEditor;
                var w3 = Common.PhoneEditor;
                var w4 = s.TextAreaEditor;
                var w5 = s.PasswordEditor;

                Q.initFormType(UserForm, [
                    'Username', w0,
                    'DisplayName', w0,
                    'Email', w1,
                    'Roles', w2,
                    'MobilePhoneNumber', w3,
                    'InvoiceAddress', w4,
                    'Password', w5,
                    'PasswordConfirm', w5,
                    'CompanyId', w2
                ]);
            }
        }
    }
}
